export const HAKLAI_PRISA_CREDIT_POINT_GENDER = Object.freeze({
  MALE: "male",
  FEMALE: "female"
});

export const HAKLAI_PRISA_CREDIT_POINT_RESIDENCY = Object.freeze({
  ISRAELI: "israeli",
  FOREIGN: "foreign"
});

export const calculateHaklaiPrisaCreditPoints = ({
  gender,
  residency
} = {}) => {
  if (!gender || !residency) return null;

  const residentPoints = residency === HAKLAI_PRISA_CREDIT_POINT_RESIDENCY.ISRAELI ? 2.25 : 0;
  const womanPoints = gender === HAKLAI_PRISA_CREDIT_POINT_GENDER.FEMALE ? 0.5 : 0;

  return residentPoints + womanPoints;
};

export const calculateHaklaiPrisaCreditPointsForPerson = (person = {}) => (
  calculateHaklaiPrisaCreditPoints({
    gender: person.creditPointGender,
    residency: person.creditPointResidency
  })
);

export const getHaklaiPrisaPersonCreditPointsValue = (person = {}) => {
  const dataPerYear = Array.isArray(person.dataPerYear) ? person.dataPerYear : [];
  return dataPerYear.length > 0 ? dataPerYear[0].zikui : "";
};
